// The query half of a browsable list, as pure functions over the URL string Inertia
// reports. No React and no DOM, so the same reads run in the browser and on a server.

import type { CollectionParams } from '@/types/collections'

// An Ark Select renders nothing at all for an unselected value, so an "any" option needs a
// real one. This is the only place that sentinel becomes "no constraint".
export const ANY_FILTER = 'all'

export function splitUrl(url: string): { path: string; query: string } {
  const withoutHash = url.split('#')[0] ?? ''
  const cut = withoutHash.indexOf('?')

  return cut === -1
    ? { path: withoutHash, query: '' }
    : { path: withoutHash.slice(0, cut), query: withoutHash.slice(cut) }
}

export function within(path: string, list: string): boolean {
  return path === list || path.startsWith(`${list}/`)
}

export function parseQuery<F>(query: string): CollectionParams<F> {
  const params: Record<string, string> = {}
  new URLSearchParams(query).forEach((value, key) => {
    params[key] = value
  })

  return params as CollectionParams<F>
}

export function readQuery<F>(url: string): CollectionParams<F> {
  return parseQuery<F>(splitUrl(url).query)
}

export function pruneQuery<F>(params: CollectionParams<F>): Record<string, string | number> {
  const cleaned: Record<string, string | number> = {}
  for (const [key, value] of Object.entries(params)) {
    if (value === '' || value === null || value === undefined) continue
    cleaned[key] = value as string | number
  }

  return cleaned
}

export function buildHref(path: string, params: Record<string, string | number>): string {
  const pairs = Object.entries(params).map(
    ([key, value]) => `${key}=${encodeURIComponent(String(value))}`,
  )

  return pairs.length ? `${path}?${pairs.join('&')}` : path
}

export function sentinelToFilter(value: string, sentinel: string = ANY_FILTER): string | undefined {
  return value === sentinel ? undefined : value
}
